import React, { useState, useEffect } from 'react';
import '../styles/landing.css';

const Landing = () => {

    useEffect(() => {
        document.addEventListener("DOMContentLoaded", function () {
            const buttons = document.querySelectorAll(".btn");

            buttons.forEach((button) => {
                button.addEventListener("mouseenter", function () {
                    this.style.transform = "translateY(-2px)";
                });

                button.addEventListener("mouseleave", function () {
                    this.style.transform = "translateY(0)";
                });
            });

            // Handle CRM dashboard redirect
            const crmButton = document.querySelector(".btn-primary");
            crmButton.addEventListener("click", function (e) {
                e.preventDefault();
                // Check if we're in development or production
                const isDev =
                    window.location.hostname === "localhost" ||
                    window.location.hostname === "127.0.0.1";
                const targetUrl = isDev
                    ? "http://localhost:3001"
                    : "/admin-dashboard";
                window.location.href = targetUrl;
            });
        });
    }, []);

    return (
        <div className="landing-page">
            <div className="landing-container">
                <div className="landing-logo-container">
                    <div className="landing-logo">
                        <img
                            src="https://premierchoicecpr.com/wp-content/uploads/2022/02/cropped-Premier_Choice_CPR.cdr_1.cdr_final-removebg-preview.png"
                            alt="Premier Choice CPR Logo"
                        />
                    </div>
                    <h1 className="landing-title">Premier Choice CPR</h1>
                    <p className="landing-subtitle">
                        Certified Experts in CPR Training & Certification
                    </p>
                </div>

                <div className="landing-button-group">
                    <a href="/dashboard" className="landing-btn landing-btn-primary">
                        <svg className="landing-icon" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                        Login to the CRM Portal
                    </a>

                    <a
                        href="https://premierchoicecpr.com"
                        target="_blank"
                        className="landing-btn landing-btn-secondary"
                        style={{ 
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            textDecoration: 'none',
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="landing-icon"
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            fill="currentColor"
                        >
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9h-3.95c-.15-2.25-.79-4.31-1.84-6.03A8.032 8.032 0 0 1 19.93 11zM12 4.07c.9 1.11 1.56 2.79 1.84 4.93H10.16C10.44 6.86 11.1 5.18 12 4.07zM4.07 13h3.95c.15 2.25.79 4.31 1.84 6.03A8.032 8.032 0 0 1 4.07 13zm3.95-2H4.07a8.032 8.032 0 0 1 6.79-6.03A15.657 15.657 0 0 0 8.02 11zm1.84 2h4.28c-.28 2.14-.94 3.82-1.84 4.93-.9-1.11-1.56-2.79-1.84-4.93zm5.12 0h3.95a8.032 8.032 0 0 1-6.79 6.03A15.657 15.657 0 0 0 14.98 13z"
                            />
                        </svg>
                        <span>Go to the CPR Website</span>
                    </a>
                </div>

                <p className="landing-footer-text">CPR Certification Management System</p>
            </div>
        </div>
    );
};

export default Landing;